import { Component, OnInit, Input } from '@angular/core';
import { CaseService } from '../../../../shared/services/case.service';
import { DateTime } from 'luxon';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-case-overview-history',
  templateUrl: './case-overview-history.component.html',
  styleUrls: ['./case-overview-history.component.scss']
})
export class CaseOverviewHistoryComponent implements OnInit {

  @Input() caseId: number;
  items: any;

  displayedColumns: string[] = ['text','addedBy', 'addedDate', 'removedBy', 'removedDate'];


  constructor( public activeModal: NgbActiveModal,
  private caseService: CaseService)
  {

  }

  ngOnInit(): void {
    this.loadItems();
  }

  loadItems(){

    this.caseService.getAllCaseOverviewItems(this.caseId).subscribe(result => {

      this.items = result.caseOverviewItems;

    }, error => {

      var errorMessage = "Failed to get case notes history";
      if (error.error !== null && error.error.message !== undefined) {
        errorMessage = error.error.message;
      }

    });
  }

  formatDate(inDate : any){

    var formattedDate = '';

    if(inDate !== null)
    {
       var dt = DateTime.fromISO(inDate);

       formattedDate = dt.toFormat("dd-MM-yyyy HH:mm:ss");

     if(formattedDate == 'Invalid date')
       formattedDate = '';

    }


     return formattedDate;

   }
}
